<div class="processing-form-host">
  <app-simulation-form-shell [loading]="loading">

      <div class="left-column" simulation-left>
        <div class="header-left">
          <button class="back-button" (click)="goBack()" [title]="'BUTTON.BACK' | translate">
            <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
          </button>
          <div class="processing-name">{{ form.name || ('PROCESSINGS.FIELDS.NAME_PLACEHOLDER' | translate) }}</div>
        </div>

        <app-assistant-trigger
          titleKey="PROCESSINGS.ASSISTANT.TITLE"
          (triggered)="showAssistant = true">
        </app-assistant-trigger>

        <div class="panel-card config-card">
          <div class="file-select-header">
            <label>{{ 'INTERACTIONS.FILES_SELECTED' | translate: { count: form.input_archive_ids.length } }}</label>
            <button class="manage-files-btn" (click)="onOpenFileManager()">
              <fa-icon [icon]="icons.faFolderOpen"></fa-icon>
              <span>{{ 'INTERACTIONS.MANAGE_FILES' | translate }}</span>
            </button>
          </div>

          @if (form.input_archive_ids.length) {
            <ng-select
              class="retriever-select"
              [items]="form.input_archive_ids"
              [(ngModel)]="activePreviewId"
              (ngModelChange)="onPreviewChange($event)"
              [clearable]="false"
              [searchable]="false"
              appendTo="body">
              <ng-template ng-label-tmp let-item="item">{{ archiveName(item) }}</ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="archive-option">
                  <span class="archive-option-name">{{ archiveName(item) }}</span>
                  <fa-icon
                    class="archive-option-download"
                    [icon]="icons.faFileArrowDown"
                    [title]="'PROCESSINGS.DOWNLOAD_ARCHIVE' | translate"
                    (click)="downloadArchive(item, $event)">
                  </fa-icon>
                </div>
              </ng-template>
            </ng-select>
          }

          @if (missingArchiveIds.length) {
            <div class="missing-archives">
              <p class="missing-archives-note">
                {{ 'PROCESSINGS.MISSING_ARCHIVES' | translate }}
              </p>
              @for (archiveId of missingArchiveIds; track archiveId) {
                <div class="missing-archive">
                  <code>{{ archiveId }}</code>
                  <button type="button" class="missing-archive-remove"
                    (click)="removeArchiveReference(archiveId)"
                    [title]="'PROCESSINGS.REMOVE_MISSING_ARCHIVE' | translate">
                    <fa-icon [icon]="icons.faTrash"></fa-icon>
                    <span>{{ 'BUTTON.DELETE' | translate }}</span>
                  </button>
                </div>
              }
            </div>
          }

          <div class="file-viewer">
            @if (form.input_archive_ids.length) {
              @if (activePreviewError) {
                <div class="preview-error">
                  <pre class="json-preview json-preview--error">{{ activePreviewError }}</pre>
                  <div class="preview-error-actions">
                    <code>{{ archiveName(activePreviewId) }}</code>
                    <button type="button" class="missing-archive-remove"
                      (click)="removeArchiveReference(activePreviewId)"
                      [title]="'PROCESSINGS.REMOVE_MISSING_ARCHIVE' | translate">
                      <fa-icon [icon]="icons.faTrash"></fa-icon>
                      <span>{{ 'PROCESSINGS.REMOVE_REFERENCE' | translate }}</span>
                    </button>
                  </div>
                </div>
              } @else {
                <app-code-viewer
                  class="processing-json-viewer processing-json-viewer--input"
                  [content]="activePreviewContent"
                  language="json">
                </app-code-viewer>
              }
            } @else {
              <div class="viewer-empty">
                <fa-icon [icon]="icons.faFolderOpen" class="viewer-empty-icon"></fa-icon>
                <p>{{ 'INTERACTIONS.NO_FILES_HINT' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="right-column" simulation-right>
        <div class="panel-card extraction-card">
          <app-tabs [tabs]="mainTabs" [(activeId)]="activeTab" variant="underline" [fullWidth]="true"></app-tabs>

          <div class="tab-panels">
            <div class="tab-panel tab-panel--config" [hidden]="activeTab !== 'config'">
              <app-simulation-model-io
                [models]="processingModels"
                [selectedModel]="selectedModelId"
                (selectedModelChange)="selectedModelId = $event; onSelectModel($event)"
                labelKey="PROCESSINGS.MODEL.LABEL"
                placeholderKey="PROCESSINGS.MODEL.PLACEHOLDER"
                (importModel)="onImportOperations()"
                (exportModel)="onExportOperations()">
              </app-simulation-model-io>
              <app-tabs [tabs]="operationTabs" [(activeId)]="activeOperationTab"
                variant="underline" [fullWidth]="true">
              </app-tabs>
              <div class="operations-section" [hidden]="activeOperationTab !== 'operations'">
                <app-processing-operations
                  [operations]="form.operations"
                  (operationsChange)="onOperationsChange($event)"
                  (testRequested)="onTestRequested($event)">
                </app-processing-operations>
              </div>
              <div class="operations-section" [hidden]="activeOperationTab !== 'catalog'">
                <app-processing-catalog
                  [catalog]="catalogData"
                  [catalogError]="catalogError"
                  (retry)="onCatalogRetry()">
                </app-processing-catalog>
              </div>
              <app-simulation-model-actions
                [(modelName)]="newModelName"
                nameLabelKey="PROCESSINGS.MODEL.NAME_LABEL"
                namePlaceholderKey="PROCESSINGS.MODEL.NAME_LABEL"
                saveLabelKey="BUTTON.SAVE"
                executeLabelKey="PROCESSINGS.EXECUTE.BUTTON"
                [showExecute]="isEditing"
                [saveDisabled]="!canSave"
                [executeDisabled]="executing"
                [saving]="saving"
                [executing]="executing"
                (save)="onSaveModel()"
                (execute)="execute()">
              </app-simulation-model-actions>
            </div>

            <div class="tab-panel tab-panel--results" [hidden]="activeTab !== 'result'">
              <app-simulation-executions-list
                [simulationId]="route.snapshot.paramMap.get('id') || ''"
                simulationType="processing"
                [executions]="executions"
                [loading]="executing && executions.length === 0">
              </app-simulation-executions-list>
            </div>
          </div>
        </div>
      </div>
  </app-simulation-form-shell>

  <app-modal-test-operation
    [show]="showTestModal"
    [operation]="testOperation"
    [llmConfigs]="llmModelOptions"
    [llmConfigId]="testLlmConfigId"
    (llmConfigIdChange)="testLlmConfigId = $event"
    [runner]="testCurrentOperation"
    (close)="showTestModal = false">
  </app-modal-test-operation>

  <app-processing-assistant
    [show]="showAssistant"
    [sample]="activePreviewContent"
    [delfosServerConfigId]="testServerId"
    [llmModel]="testLlmKey"
    (addSuggestion)="onAddSuggestion($event)"
    (close)="showAssistant = false">
  </app-processing-assistant>

  <app-modal-interaction-archives-add
    [show]="showFileManager"
    [ext]="'json'"
    [emitOnly]="true"
    [preselectedIds]="form.input_archive_ids"
    (confirmed)="onFilesConfirmed($event)"
    (close)="onCloseFileManager()">
  </app-modal-interaction-archives-add>

  <app-modal-execute-processing
    [show]="showExecuteModal"
    [delfosServerConfigs]="delfosServerConfigs"
    [delfosLlmConfigs]="llmModelOptions"
    [initialOptions]="initialExecOptions"
    (close)="onCloseExecuteModal()"
    (confirm)="onConfirmExecute($event)">
  </app-modal-execute-processing>

  <app-modal-confirm [show]="showLeaveModal" title="COMMON.UNSAVED_TITLE" message="COMMON.UNSAVED_MESSAGE"
    confirmLabel="COMMON.LEAVE" variant="warning" btnVariant="danger" (close)="onLeaveCancel()"
    (confirm)="onLeaveConfirm()">
  </app-modal-confirm>

</div>
